import {Interest} from "../../entities/entities";
import {interfaceInterestRepository} from "../../../infrastructure/repository/impl/interest_repository";

interface InterestUseCases {
  list(): Promise<Interest[]>;
  relateInterestToUser(interests): Promise<void>;
  listUserInterest(): Promise<Interest[]>;
}

class _InterestUseCases implements InterestUseCases {
  async list(): Promise<Interest[]> {
    return await interfaceInterestRepository.list();
  }

  async listUserInterest(): Promise<Interest[]> {
    return await interfaceInterestRepository.listUserInterest();
  }

  async relateInterestToUser(interests): Promise<void> {
    return await interfaceInterestRepository.relateInterestToUser(interests);
  }
}

export const InterfaceInterestUseCases: InterestUseCases = new _InterestUseCases();
